import React from "react";
import "./AboutUs.scss";

const AboutUs = () => {
  return (
    <div className="AboutUs">
      <div className="AboutUs-container">
        <img
          className="AboutUs-container_img"
          src="AboutUs/AboutUsBaner.jpg"
        ></img>
        <p className="AboutUs-container_txt">
          ¡Descubre el mundo de la tecnología Apple con nosotros! Somos tu mejor
          opción para adquirir los últimos dispositivos y accesorios de esta
          reconocida marca. En nuestra tienda online, encontrarás una amplia
          gama de productos Apple, directamente importados para ofrecerte la
          mejor calidad y garantía. Contamos con una extensa selección de
          productos Apple, desde los últimos modelos de iPhone, iPad y Mac hasta
          los AirPods y Apple Watch más recientes. Siempre estamos actualizados
          con las últimas novedades y lanzamientos de la marca.
          <br /> Trabajamos directamente con proveedores autorizados y cumplimos
          con los estándares de calidad más exigentes, lo que garantiza la
          calidad de nuestros productos. Todos nuestros productos son 100%
          originales y cuentan con la garantía de Apple.
          <br /> Con más de 5 años de experiencia en el mercado, nos enorgullece
          servir a nuestros clientes con excelencia. Durante este tiempo, hemos
          ganado la confianza de nuestros clientes al brindarles productos de
          alta calidad y un servicio excepcional.
          <br />
          Nuestro equipo de atención al cliente está disponible para brindarte
          asesoramiento y resolver cualquier consulta que puedas tener. Queremos
          asegurarnos de que tu experiencia de compra sea satisfactoria en todo
          momento. Nos esforzamos por brindar una atención al cliente
          excepcional y asegurar tu plena satisfacción.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
